import TableInput from 'components/elements/table/table-input';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { HotelRescheduleFormType } from '../form-type';
import useGetHotelRescheduleDetailTableList from '../hooks/use-get-hotel-reschedule-detail-table-list';

interface Props {
  parentIndex: number;
}

export default function OriginalHotelSaleHotel(props: Props) {
  const { control } = useFormContext<HotelRescheduleFormType>();

  const name =
    `hotelSales.${props.parentIndex}.originalHotelSaleHotels` as const;

  const hotels = useWatch({
    control,
    name,
  });

  const columns = useGetHotelRescheduleDetailTableList();

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={hotels}
        disabled
        dispatch={() => {}}
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
}
